var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{staticClass:"header"}),(_vm.loginState === true)?_c('div',[_c('Content',{staticClass:"content"}),_c('Function',{staticClass:"function"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }